import { appstr } from "@coreapp/utils/appstr";
import { getImagePath } from "@coreapp/utils/getImagePath";
import { DialogContent, Flex, Icon, Text } from "@theorgchartdev/storybook";

const BrandSetupStart = () => {
  return (
    <DialogContent customContentClass="oc-brand-setup-content oc-brand-setup-start-tab">
      <Flex direction="column" alignItems="center" gap="16px">
        <Flex
          direction="column"
          alignItems="center"
          justifyContent="center"
          className="oc-brand-setup-logo"
        >
          <img src={getImagePath("/static/images/OC-icon.svg")} alt="Org Chart Logo" />
        </Flex>
        <Text size="large" className="oc-brand-setup-welcome-text">
          {appstr("Welcome to OrgChart!")}
        </Text>
        <Text size="small">
          {appstr(
            "In two quick steps, we'll customize your org chart with your logo and brand colors."
          )}
        </Text>
      </Flex>
      <Flex gap="32px">
        <Flex gap="16px" padding="16px" className="oc-brand-setup-step-preview">
          <Flex direction="column" gap="4px">
            <Text size="medium" modifier="medium">
              {appstr("Upload your logo")}
            </Text>
            <Text size="small">{appstr("Auto-generates a branded background.")}</Text>
          </Flex>
          <Icon name="cloud-arrow-up" size="xlarge" color="brand" className="oc-shrink-0" />
        </Flex>
        <Flex gap="16px" padding="16px" className="oc-brand-setup-step-preview">
          <Flex direction="column" gap="4px">
            <Text size="medium" modifier="medium">
              {appstr("Set brand colors")}
            </Text>
            <Text size="small">{appstr("Applied to all org chart system boxes.")}</Text>
          </Flex>
          <Icon name="paintbrush" size="xlarge" color="brand" className="oc-shrink-0" />
        </Flex>
      </Flex>
    </DialogContent>
  );
};

export default BrandSetupStart;
